import gql from 'graphql-tag';

const ME = gql`
  query me {
    me {
      address
      birthday
      city
      company
      country
      createdAt
      createdBy
      email
      firstName
      id
      lastName
      registrationNumber
      roles
      subscribed
      zipCode
    }
  }
`;

const ME_BRIEF = gql`
query me {
  me {
    id
    firstName
    lastName
    email
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
  }
}
`;

const ME_QUERY = (key = 0) => {
  switch (key) {
    case 0: return ME;
    case 1: return ME_BRIEF;
    default: return ME;
  }
};

export default ME_QUERY;
